import { Component, input, signal } from '@angular/core';
import { EFeeType } from 'src/models/products.model';

@Component({
  selector: 'liberro-fee-info-tooltip',
  standalone: false,
  templateUrl: './fee-info-tooltip.component.html',
  styleUrl: './fee-info-tooltip.component.less'
})
export class FeeInfoTooltipComponent {
  public feeType = input.required<EFeeType>();

  public tooltipVisible = signal<boolean>(false);

  public onTooltipVisibleChange(visible: boolean): void {
    this.tooltipVisible.set(visible);
  }

  public onCloseTooltip(event: Event): void {
    event.stopPropagation();
    this.tooltipVisible.set(false);
  }
}
